class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.searchCount = 0;

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // @todo, refaire deux requêtes, une pour produit et une pour article
    // insérer les résultats du DOM
    // supprimer la requête /suggest
    const productRequest = new XMLHttpRequest();
    productRequest.open('GET', '/search/?view=ajax&q=' + searchTerm + '*&type=product', true);
    productRequest.responseType = 'document';
    productRequest.send(null);
    productRequest.addEventListener('readystatechange', () => {
      if (productRequest.readyState === 4) {
        const doc = productRequest.response;
        const count = doc.querySelector('.search-count');
        this.searchCount = count.textContent;
      }

      fetch(
        `/search/suggest?q=${searchTerm}*&resources[type]=product,article&resources[options][fields]=title,body,variants.title&section_id=predictive-search`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;

          this.predictiveSearchResults.innerHTML = resultsMarkup;
          if (this.querySelector('#predictive-search-count')) {
            this.querySelector('#predictive-search-count').innerHTML = this.searchCount;
          }

          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    const event = new Event('openSearch');
    window.dispatchEvent(event);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);